import { createContext, useContext, useState, type ReactNode } from 'react';

import type { AiAgentMetricKey } from '../aiAgentsInsightsConfig';

interface SelectedAiAgentMetricValue {
  selectedMetric: AiAgentMetricKey;
  setSelectedMetric: (metric: AiAgentMetricKey) => void;
}

const SelectedAiAgentMetricContext = createContext<SelectedAiAgentMetricValue | null>(null);

export const SelectedAiAgentMetricProvider = ({ children }: { children: ReactNode }) => {
  const [selectedMetric, setSelectedMetric] = useState<AiAgentMetricKey>('totalConversations');

  return (
    <SelectedAiAgentMetricContext.Provider value={{ selectedMetric, setSelectedMetric }}>
      {children}
    </SelectedAiAgentMetricContext.Provider>
  );
};

export const useSelectedAiAgentMetric = (): SelectedAiAgentMetricValue => {
  const context = useContext(SelectedAiAgentMetricContext);
  if (!context) {
    return { selectedMetric: 'totalConversations', setSelectedMetric: () => {} };
  }
  return context;
};
